"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StickyPositionType;
(function (StickyPositionType) {
    StickyPositionType[StickyPositionType["Both"] = 0] = "Both";
    StickyPositionType[StickyPositionType["Header"] = 1] = "Header";
    StickyPositionType[StickyPositionType["Footer"] = 2] = "Footer";
})(StickyPositionType = exports.StickyPositionType || (exports.StickyPositionType = {}));
//# sourceMappingURL=Sticky.Props.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Sticky/Sticky.Props.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Sticky/Sticky.Props.js
// module chunks = 1